export default "__VITE_ASSET__BPMZPety__"